import { render, staticRenderFns } from "./ChooseSupplierField.vue?vue&type=template&id=d2f52918"
import script from "./ChooseSupplierField.vue?vue&type=script&lang=js"
export * from "./ChooseSupplierField.vue?vue&type=script&lang=js"
import style0 from "./ChooseSupplierField.vue?vue&type=style&index=0&id=d2f52918&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports